module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAkAAAAJCAYAAADgkQYQAAAAAXNSR0IArs4c6QAAAHdJREFUKFONkNENgkAQRN80hlWITegXWAXyBU2oXdDYkCW3RJIzYf82+2by7sSJUTC2P8AsacmM7Qa4S2oTugBvoA2wALHfYt+g0pbgADwzELcdKmAHvIBe0pgFv03hEG71Jts1pwhsjin+BabK6x6Srgenf1+2Ahe6NwpWWbcuAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/关闭.png
// module id = jxy1
// module chunks = 54